import React from 'react';

import { sanitizeText } from 'root/apps/pages/utils/sanitize';

import { B2BItem, B2BPricing } from './Import/types';

function isMSRP(price: B2BPricing) {
  return price.type.toLowerCase() === 'msrp';
}

export function findMSRP(b2bItem: B2BItem): B2BPricing | null {
  if (!Array.isArray(b2bItem.pricing)) return null;
  return b2bItem.pricing.find(isMSRP) || null;
}

export function buildImportMSRP(msrp: B2BPricing | null) {
  if (!msrp) return null;
  const amount = parseFloat(msrp.amount);
  if (isNaN(amount)) return null;
  return {
    value: amount,
    currency: msrp.currency,
  };
}

export function varElem(content: React.ReactNode, fallback: string, sanitize = false) {
  if (!content) return fallback;
  if (sanitize) return <var>{sanitizeText(content)}</var>;
  return <var>{content}</var>;
}

export const flashSuccess = () => window.flashNotifier('success', 'Item successfully imported', 2);
export const flashError = () =>
  window.showNotifier('warning', 'Item failed to import. Try again later');

export const B2B_CALL_ROOT = `/admin/item/b2b-catalog/import`;

export const B2B_GROUP_SEACH = `/admin/item/b2b-catalog/group/search`;
